const Card = ({ title, actions, footer, className = '', children }) => (
  <div className={`card ${className}`}>
    {(title || actions) && (
      <div className="card-header flex flex-wrap items-center justify-between gap-3">
        {title ? <h5>{title}</h5> : <span />}
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      </div>
    )}
    <div className="card-body">{children}</div>
    {footer && <div className="card-footer">{footer}</div>}
  </div>
);

export default Card;
